import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 md:py-16 bg-polo-navy" data-id="element-49">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="glass-card rounded-3xl p-6 md:p-12 text-center border-polo-gold/20 relative overflow-hidden" data-id="element-51">
          <div className="absolute -top-24 -right-24 w-48 h-48 bg-polo-gold/10 rounded-full blur-3xl" data-id="element-52" />
          <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-polo-gold/10 rounded-full blur-3xl" data-id="element-53" />

          <div className="relative z-10" data-id="element-54">
            <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-polo-gold/10 text-polo-gold mb-4 md:mb-6" data-id="element-55">
              <Shield className="w-8 h-8 md:w-10 md:h-10" data-id="element-56" />
            </div>

            <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6 text-white" data-id="element-57">
              🛡️ Garantía 7 días sin riesgo
            </h2>

            <p className="text-base md:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-58">
              Estamos tan seguros de la calidad de este material que te
              ofrecemos una garantía total. Si no te convence, te devolvemos el
              100% de tu dinero. Sin preguntas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}